import "./style.scss";
import { handleTypeNumberControl } from "src/utils/utility";
import { useContext, useEffect, useState } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import {
  AppText,
  Button,
  CustomContainer,
  Form,
  FormGroup,
  FormGroupWithIcon,
  ScreenContainer,
} from "src/style";
import UserContext from "src/provider/state-manager/userProvider";
import { FiChevronDown } from "react-icons/fi";
import { useGetCbpDocs } from "src/hooks/cbp/useGetCbpDocs";
import { convertToTitleCase } from "src/utils/helpers";

interface CbpConfirmProps {
  onNext: () => void;
}
const CbpConfirmDetails = ({ onNext }: CbpConfirmProps) => {
  const { user, setUserProperty } = useContext(UserContext);

  const [input, setInput] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    nationality: "",
    dateOfBirth: "",
    phoneNo: "",
    gender: "",
    identificationType: "",
    identificationNumber: "",
  });

  useEffect(() => {
    if (user?.userInfo) {
      const {
        firstName,
        middleName,
        lastName,
        nationality,
        dateOfBirth,
        phoneNumber,
        gender,
      } = user?.userInfo?.profileInfo;
      setInput({
        ...input,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        nationality: nationality,
        dateOfBirth: dateOfBirth,
        phoneNo: phoneNumber,
        gender: String(gender),
      });
    }
  }, [user?.userInfo]);

  const { data } = useGetCbpDocs();

  const documentTitles = data?.map((doc: any) => ({
    name: convertToTitleCase(doc?.name),
    value: doc?.name,
  }));

  const complianceList: { label: string; value: string }[] = [
    {
      label: "Passport",
      value: "Passport",
    },
    {
      label: "Drivers_license",
      value: "Drivers_license",
    },
    {
      label: "Bvn",
      value: "Bvn",
    },
    {
      label: "Nin",
      value: "Nin",
    },
    {
      label: "National_id",
      value: "National_id",
    },
    {
      label: "Company_number",
      value: "Company_number",
    },
    {
      label: "Other_id",
      value: "Other_id",
    },
  ];

  console.log("documents", input);

  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
    setUserProperty("onboardingInput", { ...input });
  };

  const handleNext = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onNext();
  };

  return (
    <>
      <CustomContainer className="cbp-container">
        <AppText
          textSize="3"
          color="#101828"
          bottomMargin="1.5"
          fontFamily="Gilmer-Bold"
        >
          Confirm your details
        </AppText>

        <Form topMargin="3" onSubmit={handleNext}>
          <FormGroup bottomMargin="2">
            <label>First Name</label>
            <input
              name="firstName"
              placeholder="Enter First Name"
              value={input.firstName}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup>

          <FormGroup bottomMargin="2">
            <label>Middle Name</label>
            <input
              className="cbp-input"
              name="middleName"
              placeholder="Enter Middle Name"
              value={input.middleName}
              onChange={handleInput}
              autoComplete="off"
            />
          </FormGroup>

          <FormGroup bottomMargin="2">
            <label>Last Name</label>
            <input
              name="lastName"
              placeholder="Enter Last Name"
              value={input.lastName}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup>
          <FormGroupWithIcon bottomMargin="2">
            <label>Gender</label>
            <div className="input-with-icon">
              <select
                placeholder="Select Gender"
                name="gender"
                value={input.gender}
                style={{ color: input.gender ? "#000000" : "#667085" }}
                onChange={handleInput}
                required
              >
                <option value="">--Select Gender--</option>
                <option value="0">Male</option>
                <option value="1">Female</option>
              </select>
              <FiChevronDown className="input-with-icon-tag" />
            </div>
          </FormGroupWithIcon>

          {/* <FormGroup bottomMargin="2">
            <label>BVN</label>
            <input
              name="bvn"
              placeholder="Enter your bvn"
              value={input.bvn}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup>

          <FormGroup bottomMargin="2">
            <label>NIN</label>
            <input
              name="nin"
              placeholder="Enter your nin"
              value={input.nin}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup> */}

          <FormGroup bottomMargin="2">
            <label>Date of Birth</label>
            <input
              placeholder="dd/mm/yyyy"
              type="date"
              name="dateOfBirth"
              style={{ color: input.dateOfBirth ? "#000000" : "#667085" }}
              value={input.dateOfBirth}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup>
          <FormGroup bottomMargin="2">
            <label>Nationality</label>
            <input
              name="nationality"
              placeholder="Enter your nationality"
              value={input.nationality}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup>

          <FormGroup bottomMargin="2">
            <label>Phone Number</label>
            <input
              type="number"
              name="phoneNo"
              placeholder="Enter Phone Number"
              value={input.phoneNo}
              onChange={handleInput}
              onKeyDown={handleTypeNumberControl}
              onKeyUp={handleTypeNumberControl}
              autoComplete="off"
              required
            />
          </FormGroup>
          <FormGroupWithIcon bottomMargin="2">
            <label>Choose your identification type</label>
            <div className="input-with-icon">
              <select
                placeholder="Select Type"
                name="identificationType"
                value={input.identificationType}
                style={{
                  color: input.identificationType ? "#000000" : "#667085",
                }}
                onChange={handleInput}
                required
              >
                <option value="">Select Type</option>
                {complianceList?.map((title: any, index: number) => (
                  <option key={index} value={title?.value}>
                    {title?.label}
                  </option>
                ))}
              </select>
              <FiChevronDown className="input-with-icon-tag" />
            </div>
          </FormGroupWithIcon>
          <FormGroup>
            <label>ID Number</label>
            <input
              placeholder="Enter ID Number"
              name="identificationNumber"
              value={input.identificationNumber}
              onChange={handleInput}
              autoComplete="off"
              required
            />
          </FormGroup>
          <Button
            height="4"
            borderColor="#0D968F"
            hoverBgColor="#fff"
            hoverColor="#0D968F"
            titleSize="1.4"
            align="center"
            topMargin="2"
            bottomMargin="5"
            style={{ width: "100%" }}
          >
            Next
          </Button>
        </Form>
      </CustomContainer>
    </>
  );
};

export default CbpConfirmDetails;
